import React from 'react';

interface ICreateTeamModal {
  setNewMode: any;
  newTeamName: string;
  setNewTeamName: any;
  handleCreateNew: any;
}

const CreateTeamModal: React.FC<ICreateTeamModal> = ({ setNewMode, setNewTeamName, newTeamName, handleCreateNew }) => {
  return (
    <div className='create-team-modal'>
      <div className='create-team-header'>
        <div className='create-team-header-content'>
          <div className='create-team-header-icon'>
            <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
              <path d='M12 5V19M5 12H19' stroke='#4895EF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
            </svg>
          </div>
          <div className='create-team-header-group'>
            <div className='create-team-header-primary'>
              Create New Team
            </div>
            <div className='create-team-header-secondary'>
              You will automatically be made the admin of this new team.
            </div>
          </div>
        </div>
        <div className='create-team-header-close' onClick={() => setNewMode(false)}>
          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
            <path d='M18 6L6 18M6 6L18 18' stroke='#BDBEC1' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
          </svg>
        </div>
      </div>
      <div className='create-team-body'>
        <div className='create-team-body-frame'>
          <div className='create-team-label'>
            New Team Name
          </div>
          <div className='team-name-form'>
            <input
              id='searchVal'
              placeholder='Enter your team name...'
              type='text'
              className='create-team-name-input'
              name='newTeamName'
              value={newTeamName}
              onChange={(e) => setNewTeamName(e.target.value)}
            />
          </div>
        </div>
      </div>
      <div className='create-team-modal-footer'>
        <div className='create-team-modal-footer-wrap'></div>
        <div className='create-team-modal-footer-actions'>
          <div className='create-team-modal-footer-actions-frame'>
            <div className='create-team-footer-cancel' onClick={() => setNewMode(false)}>
              <div className='create-team-footer-cancel-text'>
                Cancel
              </div>
            </div>
            <div className='create-team-footer-create' onClick={() => handleCreateNew(newTeamName)}>
              <div className='create-team-footer-create-text'>
                Create Team
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateTeamModal;
